// Centralized API base URL for building absolute resource URLs
export const API_BASE = process.env.REACT_APP_API_URL || 'http://hmsc44:8110';